import { atom } from "jotai";
import { showActiveAnnotationNodeSetter } from "./showActiveAnnotationNodeSetter";
import {
  isGeneratingTourAtom,
  isGeneratingExplanationAtom,
  isTourAlertVisibleAtom,
} from "./tourStateAtoms";
import { nodeIdToExplainAtom, tourIntroStepAtom } from "./tourStateAtoms";

/**
 * Setter for exiting tours and explanations.
 *
 * Behavior:
 * - Hides all annotation nodes (sets active step to 0)
 * - Clears all annotation state
 * - Shows completion alert only for actual tours (not single node explanations)
 * - Only clears pending explanation state if the annotation being closed matches the pending explanation
 */
export const tourExitSetter = atom(null, (get, set, parentId?: string) => {
  // Always hide all annotation nodes
  set(showActiveAnnotationNodeSetter, null);

  const nodeIdToExplain = get(nodeIdToExplainAtom);
  const isGeneratingExplanation = get(isGeneratingExplanationAtom);

  // Show alert if it was a tour (not a single node explanation)
  if (!nodeIdToExplain && !isGeneratingExplanation) {
    set(isTourAlertVisibleAtom, true);
  }

  // Complete operation and clear all state
  set(isGeneratingTourAtom, false);

  // Only clear explanation state if:
  // 1. No explanation is currently being generated, OR
  // 2. The annotation being closed matches the node currently being explained
  if (!isGeneratingExplanation || parentId === nodeIdToExplain) {
    set(isGeneratingExplanationAtom, false);
    set(nodeIdToExplainAtom, null);
  }

  set(tourIntroStepAtom, null);
});

tourExitSetter.debugLabel = "tourExitSetter";
